// vendors.js - Third-party dependencies
// Generated on: 2025-05-13T22:07:26.967Z
// Add your third-party imports here

// Examples:
// import 'countup.js';
import 'swiper';
import 'intersection-observer';
import 'nodelist-foreach-polyfill';


console.log('Vendor libraries initialized');
